export default __webpack_public_path__ + "static/media/deniz-sosyal.5a59a022.jpg";